import React, { useEffect, useState } from "react";
import { actionType } from "../Context/reducer";
import { useStateValue } from "../Context/StateProvider";
import { getAllAlbums, getAllArtist, getAllSongs } from "../api";
import { filterByLanguage, filters } from "../utils/supportfunctions";
import FilterButtons from "./FilterButtons";
import { MdCancel, MdClearAll } from "react-icons/md";
import { FaMusic } from "react-icons/fa";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { motion } from "framer-motion";
import { IoMusicalNote } from "react-icons/io5";
import { RiPlayListFill } from "react-icons/ri";

const Filter = ({ setFilteredSongs }) => {
  const [{ filterTerm, artists, allAlbums }, dispatch] = useStateValue();
  const [isPlayList, setIsPlayList] = useState(false);

  useEffect(() => {
    if (!artists) {
      getAllArtist().then((data) => {
        dispatch({ type: actionType.SET_ARTISTS, artists: data.data });
      });
    }

    if (!allAlbums) {
      getAllAlbums().then((data) => {
        dispatch({ type: actionType.SET_ALL_ALBUMNS, allAlbums: data.data });
      });
    }
  }, []);

  const updateFilter = (value) => {
    dispatch({
      type: actionType.SET_FILTER_TERM,
      filterTerm: value,
    });
  };

  const [nav, setNav] = useState(true);

  const handleNav = () => {
    setNav(!nav);
  };

  const clearAllFilter = () => {
    setFilteredSongs(null);
    dispatch({ type: actionType.SET_ARTIST_FILTER, artistFilter: null });
    dispatch({ type: actionType.SET_LANGUAGE_FILTER, languageFilter: null });
    dispatch({ type: actionType.SET_ALBUM_FILTER, albumFilter: null });
    dispatch({ type: actionType.SET_FILTER_TERM, filterTerm: null });
  };
  return (
    <div>
      <div
        onClick={handleNav}
        className="block absolute left-[90%] md:top-[23%] top-[33%] md:"
      >
        {!nav ? (
          <AiOutlineClose
            size={25}
            className="cursor-pointer text-red-600 border-2 border-red-500 rounded-full p-1"
          />
        ) : (
          <FaMusic
            size={29}
            className="cursor-pointer border-2 border-red-500 rounded-full p-1 text-red-600 text-9xl mt-[-330%] ease-in-out duration-500  md:mt-0"
          />
        )}
      </div>
      <div
        className={
          !nav
            ? "w-full my-4 px-6 py-4 md:flex items-center justify-start md:justify-center ease-in-out duration-500 drop-shadow-4xl gap-10"
            : "fixed  left-[-100%]"
        }
      >
        <FilterButtons filterData={artists} flag={"Artist"} />

        <div className="items-center gap-6 md:flex mx-4">
          {filters?.map((data) => (
            <p
              key={data.id}
              onClick={() => updateFilter(data.value)}
              className={`text-base ${
                data.value === filterTerm ? "font-semibold" : "font-normal"
              } text-textColor cursor-pointer hover:font-semibold transition-all duration-100 ease-in-out`}
            >
              {data.name}
            </p>
          ))}
        </div>

        <FilterButtons filterData={allAlbums} flag={"Albums"} />

        <FilterButtons filterData={filterByLanguage} flag={"Language"} />

        <motion.i
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          whileTap={{ scale: 0.75 }}
          onClick={clearAllFilter}
        >
          <MdClearAll className="text-textColor text-xl cursor-pointer z-50" />
          <motion.i
            whileTap={{ scale: 0.8 }}
            onClick={() => setIsPlayList(!isPlayList)}
          >
            <RiPlayListFill className="text-textColor hover:text-headingColor text-3xl cursor-pointer md:hidden z-50" />
          </motion.i>
        </motion.i>
        <div className="z-50">
          {isPlayList && (
            <>
              <MdCancel
                className="text-red-600 hover:text-headingColor text-2xl
              cursor-pointer absolute top-[12%] right-[7%] z-50"
                onClick={() => setIsPlayList(false)}
              />
              <PlayListCard />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const PlayListCard = () => {
  const [{ allSongs, song, isSongPlaying }, dispatch] = useStateValue();
  useEffect(() => {
    if (!allSongs) {
      getAllSongs().then((data) => {
        dispatch({
          type: actionType.SET_ALL_SONGS,
          allSongs: data.data,
        });
      });
    }
  }, []);

  const setCurrentPlaySong = (songindex) => {
    if (!isSongPlaying) {
      dispatch({
        type: actionType.SET_SONG_PLAYING,
        isSongPlaying: true,
      });
    }
    if (song !== songindex) {
      dispatch({
        type: actionType.SET_SONG,
        song: songindex,
      });
    }
  };

  return (
    <div className="absolute left-4 bottom-24 gap-2 py-2 w-350 max-w-[350px] h-510 max-h-[510px] flex flex-col overflow-y-scroll scrollbar-thin rounded-md shadow-md bg-primary">
      {allSongs.length > 0 ? (
        allSongs.map((music, index) => (
          <motion.div
            initial={{ opacity: 0, translateX: -50 }}
            animate={{ opacity: 1, translateX: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className={`group w-full p-4 hover:bg-card flex gap-3 items-center cursor-pointer ${
              music?._id === song._id ? "bg-card" : "bg-transparent"
            }`}
            onClick={() => setCurrentPlaySong(index)}
          >
            <IoMusicalNote className="text-textColor group-hover:text-headingColor text-2xl cursor-pointer" />

            <div className="flex items-start flex-col">
              <p className="text-lg text-headingColor font-semibold">
                {`${
                  music?.name.length > 20
                    ? music?.name.slice(0, 20)
                    : music?.name
                }`}{" "}
                <span className="text-base">({music?.album})</span>
              </p>
              <p className="text-textColor">
                {music?.artist}{" "}
                <span className="text-sm text-textColor font-semibold">
                  ({music?.category})
                </span>
              </p>
            </div>
          </motion.div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default Filter;
